import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, CONTACT, QUOTE_PATH } from "../../lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-forest text-white">
    <div className="container-x pt-24 pb-10">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo light />
          <p className="mt-6 max-w-sm text-white/75 leading-relaxed">
            Instalação de painéis solares fotovoltaicos para habitações e empresas em Portugal.
          </p>
          <Link to={QUOTE_PATH} className="btn-gold mt-8" data-testid="footer-quote-button">Pedir Orçamento Gratuito</Link>
        </div>
        <nav aria-label="Rodapé" className="lg:col-span-3">
          <p className="eyebrow text-gold mb-5">Navegação</p>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.to}><Link to={n.to} className="text-white/80 hover:text-gold transition-colors">{n.label}</Link></li>
            ))}
            <li><Link to={QUOTE_PATH} className="text-white/80 hover:text-gold transition-colors">Pedir Orçamento</Link></li>
          </ul>
        </nav>
        <div className="lg:col-span-4">
          <p className="eyebrow text-gold mb-5">Contactos</p>
          <ul className="space-y-4">
            <li><a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-3 text-white/90 hover:text-gold transition-colors"><Phone className="h-4 w-4" /> {CONTACT.phoneDisplay}</a></li>
            <li><a href={CONTACT.whatsappHref} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-3 text-white/90 hover:text-gold transition-colors"><MessageCircle className="h-4 w-4" /> WhatsApp</a></li>
            <li><a href={CONTACT.emailHref} data-testid="footer-email-link" className="flex items-center gap-3 text-white/90 hover:text-gold transition-colors"><Mail className="h-4 w-4" /> {CONTACT.email}</a></li>
          </ul>
        </div>
      </div>
      <p aria-hidden="true" className="mt-20 select-none font-display font-semibold leading-[0.8] tracking-tighter text-white/[0.06] text-[22vw] lg:text-[17vw] whitespace-nowrap">
        MEGA SOLAR
      </p>
      <div className="mt-8 flex flex-col gap-4 border-t border-white/15 pt-8 text-sm text-white/70 sm:flex-row sm:items-center sm:justify-between">
        <p>© {new Date().getFullYear()} Mega Solar · NIPC 517433907. Todos os direitos reservados.</p>
        <div className="flex gap-6">
          <Link to="/politica-de-privacidade" className="hover:text-gold transition-colors" data-testid="footer-privacy-link">Política de Privacidade</Link>
        </div>
      </div>
    </div>
  </footer>
);
